import { c as _c } from "react/compiler-runtime";
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
export function VocabularyMenu(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <DropdownMenuTrigger aria-label="vocabulary menu" render={<Button className="flex max-h-full gap-1 p-2! [--sq-r:.75rem]" variant="ghost"><svg className="icon-[ion--ellipsis-horizontal-circle-outline] size-4.75" /><svg className="icon-[lucide--chevron-down] size-3.5" /></Button>} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <DropdownMenu>{t1}<DropdownMenuContent className="w-52" align="start">{children}</DropdownMenuContent></DropdownMenu>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}